import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { DocsBlockRichTextPropertyStyle } from "../../../../../enums/SDKDocsBlockRichTextPropertyStyle";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.rich-text";
const name = "Text";
const icon = "https://cdn-assets.supernova.io/blocks/icons/v3/text.svg";
const descriptionShort = "Plain text";
const searchKeywords = ["paragraph", "rich text"];
const descriptionFull = "Use rich text block to write text and add additional formatting to it.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/text/text-HxZ9ssJR";
/**
 * 2. Block properties
 */
const properties = {
    text: b.richTextProperty({
        id: "text",
        name: "Text",
        options: {
            richTextStyle: DocsBlockRichTextPropertyStyle.default,
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.text],
    appearance: {
        isEditorPresentationDifferent: false,
    },
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.text],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.text,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as RichText };
